var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 8.9C26 6.1938 28.1662 4 30.8382 4H68.1618C70.8338 4 73 6.1938 73 8.9V27.1C73 29.8062 70.8338 32 68.1618 32H30.8382C28.1662 32 26 29.8062 26 27.1V8.9ZM35.6765 13.8V22.2H63.3235V13.8H35.6765Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 17.9C7 15.1938 9.20158 13 11.9174 13H30.1818C32.8976 13 35.0992 15.1938 35.0992 17.9V22.1H63.1983V17.9C63.1983 15.1938 65.3999 13 68.1157 13H87.0826C89.7984 13 92 15.1938 92 17.9V92.1C92 94.8062 89.7984 97 87.0826 97H11.9174C9.20158 97 7 94.8062 7 92.1V17.9ZM73.0331 22.8V27C73.0331 29.7062 70.8315 31.9 68.1157 31.9H30.1818C27.466 31.9 25.2645 29.7062 25.2645 27V22.8H16.8347V87.2H82.1653V22.8H73.0331Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 47C26 44.2386 28.1843 42 30.8788 42H67.1212C69.8157 42 72 44.2386 72 47C72 49.7614 69.8157 52 67.1212 52H30.8788C28.1843 52 26 49.7614 26 47Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 70C26 67.2386 28.1938 65 30.9 65H49.1C51.8062 65 54 67.2386 54 70C54 72.7614 51.8062 75 49.1 75H30.9C28.1938 75 26 72.7614 26 70Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/Board.8ef3552b7ff75f82b55ce5195092c0a8.svg";
export { ForwardRef as ReactComponent };